<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Pflege",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="PflegeList"></CMSSinglePage>
</template>

<style scoped>

</style>
